export const javaCode = `class Progman{
    public static void main(String[] args) {
         System.out.println("Codium"); 
    }
  }`;

export const pythonCode = `def main():
    print("Codium")
    
main()`;

export const javascriptCode = `function main() {
    console.log("Codium");
}

main();`;

export const cppCode = `#include <iostream>
using namespace std;

int main() {
    cout << "Codium" << endl;
    return 0;
}`;

export const cSharpCode = `using System;

namespace HelloWorld
{
    class Program
    {
        static void Main(string[] args)
        {
            Console.WriteLine("Codium");
        }
    }
}`;
